import { ModalHandler } from '@app-velocity/ui';

import { SavePluginModalContent } from './components/SavePluginModalContent';

export const SavePluginModal = () => {
  return (
    <ModalHandler
      id="save-plugin"
      channel="system"
    >
      <SavePluginModalContent />
    </ModalHandler>
  );
};
